module.exports = __webpack_public_path__ + "media/images/flags/gp-092b6bf958cd4a1f76c928e77991adf0.svg";